import classnames from 'classnames';
import * as React from 'react';
import { Nav, Navbar, NavbarProps } from 'reactstrap';
import './Topbar.scss';

const TopBar: React.SFC<NavbarProps> = ({className, ...rest}) => {
    return (
        <Navbar dark={true} className={classnames('topbar', className)} fixed="top" expand="md" {...rest} >
            <Nav className="ml-auto" navbar={true}>
                {/* <LanguageSelector /> */}
            </Nav>
        </Navbar>
    );
};

export default TopBar;